import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18next from 'i18next';

import eventReducer from './eventReducer';

// Actions importation
import {
  fetchEvent,
  updateEvent,
  clearEvent,

  fetchTicketList,
  fetchTicket,
  createTicket,
  updateTicket,
  clearTicket,

  updateEventSettings,

  clearPurchase
} from './eventActions';

// Components importation
import EventAdminPage from './admin/pages/EventAdminPageContainer';
import EventAdminCampaignTicketList from './admin/components/EventAdminCampaignTicketListContainer';
import CampaignCreationBehaviorField from './public/components/CampaignCreationBehaviorField';
import PublicEventInfo from './public/components/PublicEventInfoContainer';
import PublicEventThermometer from './public/components/PublicEventThermometerContainer';
import EventAdminCampaignFields from './admin/components/EventAdminCampaignFields';
import BuyTicketsPage from './public/pages/BuyTicketsPageContainer';
import TicketsDetailsForm from './public/components/TicketsDetailsFormContainer';
import ConfirmationTicketList from './public/components/ConfirmationTicketListContainer';
import EventAdminSidebarAttendees from './admin/components/Sidebars/EventAdminSidebarAttendeesContainer';
import EventAdminAttendeesCheckinPage from './admin/pages/EventAdminAttendeesCheckinPageContainer';
import EventAdminMyContributionsListTickets from './admin/components/EventAdminMyContributionsListTicketsContainer';
import EventAdminAttendeesTicketPage from './admin/pages/EventAdminAttendeesTicketPageContainer';
import BuyTicketBtn from './public/components/BuyTicketBtnContainer';
import EventAdminCampaignSettingsTransactionsPanel from './admin/components/EventAdminCampaignSettingsTransactionsPanelContainer';
import EventAdminCampaignSettingsTransactionsTabRoute from './admin/components/EventAdminCampaignSettingsTransactionsTabRoute';
import EventAdminCampaignTransactionsListTicket from './admin/components/EventAdminCampaignTransactionsListTicket';
import EventAdminCommunicationsPage from './admin/pages/EventAdminCommunicationsPage';

import EventAdminAttendeesTeamsListPage from '../../../dashboard/campaigns/teams/CampaignsTeamsListPageContainer';
import EventAdminAttendeesParticipantsListPage from '../../../dashboard/campaigns/participants/CampaignsParticipantsListPageContainer';
import EventAdminAttendeesTeamPage from '../../../dashboard/campaigns/teams/CampaignsTeamsPageContainer';
import EventAdminAttendeesParticipantPage from '../../../dashboard/campaigns/participants/CampaignsParticipantsPageContainer';

import EventAdminAddOfflineTicketPage from './admin/pages/EventAdminAddOfflineTicketPageContainer'

import event_en from './locales/Event_en.json';
import event_fr from './locales/Event_fr.json';

class Event extends Component {
  constructor(props) {
    super(props);

    // Actions listing
    this.actions = {
      fetchEvent: props.fetchEvent,
      updateEvent: props.updateEvent,
      clearEvent: props.clearEvent,

      fetchTicketList: props.fetchTicketList,
      fetchTicket: props.fetchTicket,
      createTicket: props.createTicket,
      updateTicket: props.updateTicket,
      clearTicket: props.clearTicket,

      updateEventSettings: props.updateEventSettings,

      clearPurchase: props.clearPurchase
    };

    // Components listing
    this.components = {
      AdminPage: EventAdminPage,
      EventAdminCampaignTicketList: EventAdminCampaignTicketList,
      CampaignCreationBehaviorField: CampaignCreationBehaviorField,
      PublicEventInfo: PublicEventInfo,
      PublicEventThermometer: PublicEventThermometer,
      EventAdminCampaignFields: EventAdminCampaignFields,
      BuyTicketsPage: BuyTicketsPage,
      TicketsDetailsForm: TicketsDetailsForm,
      ConfirmationTicketList: ConfirmationTicketList,
      EventAdminSidebarAttendees: EventAdminSidebarAttendees,
      EventAdminMyContributionsListTickets: EventAdminMyContributionsListTickets,
      EventAdminAttendeesCheckinPage: EventAdminAttendeesCheckinPage,
      EventAdminAttendeesTicketPage: EventAdminAttendeesTicketPage,
      EventAdminAttendeesTeamsListPage: EventAdminAttendeesTeamsListPage,
      EventAdminAttendeesParticipantsListPage: EventAdminAttendeesParticipantsListPage,
      EventAdminAttendeesTeamPage: EventAdminAttendeesTeamPage,
      EventAdminAttendeesParticipantPage: EventAdminAttendeesParticipantPage,
      BuyTicketBtn: BuyTicketBtn,
      EventAdminCampaignSettingsTransactionsPanel: EventAdminCampaignSettingsTransactionsPanel,
      EventAdminCampaignSettingsTransactionsTabRoute: EventAdminCampaignSettingsTransactionsTabRoute,
      EventAdminCampaignTransactionsListTicket: EventAdminCampaignTransactionsListTicket,
      EventAdminCommunicationsPage: EventAdminCommunicationsPage,
      EventAdminAddOfflineTicketPage: EventAdminAddOfflineTicketPage
    };

    i18next.addResourceBundle('en', 'Event', event_en);
    i18next.addResourceBundle('fr', 'Event', event_fr);
  }

  render() {
    const { component } = this.props;
    const EventComponent = component ? this.components[component] : null;
    return EventComponent ? <EventComponent {...this.props} /> : null;
  }
}

const mapStateToProps = state => ({
  Event: state.Event,
  state: state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchEvent,
      updateEvent,
      clearEvent,

      fetchTicketList,
      fetchTicket,
      createTicket,
      updateTicket,
      clearTicket,

      updateEventSettings,

      clearPurchase
    },
    dispatch
  );

const view = connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Event);

export default {
  name: 'Event',
  view,
  reducers: eventReducer
};
